/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
  GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  GetApiV1IndividualpaymentEditorsCoupons401,
  GetApiV1IndividualpaymentEditorsCoupons500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsCoupons.ts";

function getGetApiV1IndividualpaymentEditorsCouponsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/coupons` as const,
  };
  return res;
}

/**
 * @description Filtra por descrição ou código; rótulo "Descrição - [x%]" ou "Descrição - [R$ x]". Migrado do legado CouponAsync/GetActiveCouponsDropDownList. **(Requer Authorization para autenticação)**
 * @summary Cupons ativos e vigentes (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/coupons}
 */
export async function getApiV1IndividualpaymentEditorsCoupons(
  params?: GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsCoupons401
      | GetApiV1IndividualpaymentEditorsCoupons500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsCouponsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
